import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=7d473de3&scoped=true&lang=pug&"
import script from "./ModalBase.vue?vue&type=script&lang=ts&"
export * from "./ModalBase.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=7d473de3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d473de3",
  null
  
)

export default component.exports